import { useContext, useEffect, useState } from 'react';
import MainContext from '../../_helpers/Contexts/mainContext';
import contrast from '../../_assets/highcontrast.svg';
import logo from '../../_assets/Herb.png';
import './Navbar.css';
import AnimateHeight from 'react-animate-height';
import { confirm } from 'devextreme/ui/dialog';
import { Popup } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import WCAGComponent from './WCAGComponent';

const NavbarWCAG = ({ title }) => {
    const { theme, setTheme } = useContext(MainContext);
    const { sizeTheme, setSizeTheme } = useContext(MainContext);
    const [height, setHeight] = useState(40);
    const [textSize, setTextSize] = useState(2);
    const [namePage, setNamePage] = useState('');
    const [visiblePopupDeclarationOfAvailability, setVisiblePopupDeclarationOfAvailability] = useState(false);

    useEffect(() => {
        title.length > 40 ? setNamePage(title.split('-')[0] + ' - ') : setNamePage('');
    }, []);

    const controlNavbar = () => {
        if (window.scrollY > 80) setHeight(40);
        else setHeight(80);
    };

    const changeTheme = () => {
        if (setTheme) {
            if (theme === 'theme-contrast') {
                setTheme('default');
                localStorage.setItem('theme', 'default');
            } else {
                setTheme('theme-contrast');
                localStorage.setItem('theme', 'theme-contrast');
            }
        }
    };

    const step = 10;

    const zoomIn = () => {
        if (setSizeTheme && sizeTheme && sizeTheme < 150) {
            let newSizeTheme = sizeTheme + step;
            setSizeTheme(newSizeTheme);
            localStorage.setItem('sizeTheme', newSizeTheme);
        }
        setTextSize(3);
    };

    const zoomOut = () => {
        if (setSizeTheme && sizeTheme && sizeTheme > 80) {
            let newSizeTheme = sizeTheme - step;
            setSizeTheme(newSizeTheme);
            localStorage.setItem('sizeTheme', newSizeTheme);
        }
        setTextSize(1);
    };

    const resetZoom = () => {
        if (setSizeTheme) {
            setSizeTheme(100);
            localStorage.setItem('sizeTheme', 100);
        }
        setTextSize(2);
    };

    useEffect(() => {
        if (localStorage.getItem('theme')) setTheme(localStorage.getItem('theme'));
        if (localStorage.getItem('sizeTheme')) setSizeTheme(parseInt(localStorage.getItem('sizeTheme')));
        setHeight(80);
        window.addEventListener('scroll', controlNavbar);
    }, []);

    const openDeclarationOfAvailability = async () => {
        //setVisiblePopupDeclarationOfAvailability(true);
        const yes = await confirm('Czy na pewno chcesz otworzyć nową kartę z deklaracją dostępności?', 'UWAGA!');
        if (yes) {
            window.open('/AccessibilityDeclaration');
        }
    };

    return (
        <>
            <header className="navbar navBar">
                <div className="col-1 d-flex justify-content-center">
                    <AnimateHeight id="siteLogo" className="siteLogo" duration={200} height={height} style={{ backgroundImage: `url(${logo})` }}>
                        <></>
                    </AnimateHeight>
                </div>
                <div id="navHeader" className="navHeader">
                    <div>
                        {namePage} <span className="initial">e</span> - Kreator deklaracji
                    </div>
                </div>
                <div className="float-right wcag">
                    
                    <a
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            changeTheme();
                        }}
                    >
                        <img src={contrast} alt="Zmiana kontrastu" className="imgButton" onClick={changeTheme} />
                    </a>
                    <a href="" onClick={zoomOut}>
                        <span
                            className="fontToLower"
                            onClick={(e) => {
                                e.preventDefault();
                                zoomOut();
                            }}
                            id="1"
                        >
                            {textSize === 1 ? (
                                <b>
                                    <u>A-</u>
                                </b>
                            ) : (
                                'A-'
                            )}
                        </span>
                    </a>
                    <a href="" onClick={resetZoom}>
                        <span
                            className="fontToNormal"
                            onClick={(e) => {
                                e.preventDefault();
                                resetZoom();
                            }}
                            id="2"
                        >
                            {textSize === 2 ? (
                                <b>
                                    <u>A</u>
                                </b>
                            ) : (
                                'A'
                            )}
                        </span>
                    </a>
                    <a href="" onClick={zoomIn}>
                        <span
                            className="fontToUpper"
                            onClick={(e) => {
                                e.preventDefault();
                                zoomIn();
                            }}
                            id="3"
                        >
                            {textSize === 3 ? (
                                <b>
                                    <u>A+</u>
                                </b>
                            ) : (
                                'A+'
                            )}
                        </span>
                    </a>
                </div>
            </header>
        </>
    );
};

export { NavbarWCAG };
